import { render, staticRenderFns } from "./AboutAuthor.vue?vue&type=template&id=8ed76a10&scoped=true&"
import script from "./AboutAuthor.vue?vue&type=script&lang=js&"
export * from "./AboutAuthor.vue?vue&type=script&lang=js&"
import style0 from "./AboutAuthor.vue?vue&type=style&index=0&id=8ed76a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed76a10",
  null
  
)

export default component.exports